/**
 * Tenant-Branding-Application: setzt CSS-Variablen aus user.branding.
 * Default: TFC-Grün #34C369 falls kein Tenant-Override.
 *
 * Wird aus AuthProvider beim /me-Lookup aufgerufen sobald User loaded.
 */
import type { MeResponse } from './api';

const STYLE_ID = 'leadcraft-branding-vars';

export function applyBranding(branding: MeResponse['branding'] | null | undefined): void {
  const primary = branding?.primary_color ?? '#34C369';
  // Validate hex-color (XSS-prevention falls Backend mal andere Werte liefert)
  const safe = /^#[0-9A-Fa-f]{6}$/.test(primary) ? primary : '#34C369';

  let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  // Override TFC-token --tfc-green mit Tenant-primary-color.
  // Block-10-Phase-1: nur primary_color whitelabel-bar. Logo wird separat gerendert.
  style.textContent = `:root { --tfc-green: ${safe}; --tfc-state-hover: ${darken(safe, 0.1)}; }`;
}

export function clearBranding(): void {
  const style = document.getElementById(STYLE_ID);
  if (style) style.remove();
}

function darken(hex: string, factor: number): string {
  const m = /^#([0-9A-Fa-f]{6})$/.exec(hex);
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = Math.max(0, Math.floor(((n >> 16) & 0xff) * (1 - factor)));
  const g = Math.max(0, Math.floor(((n >> 8) & 0xff) * (1 - factor)));
  const b = Math.max(0, Math.floor((n & 0xff) * (1 - factor)));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}
